export default __webpack_public_path__ + "images/96a78502f7368e534cd54b64e56501c0.png";